/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_SubInputs */

const en_mk_sec_sub = /** @type {(inputs: Mk_Sec_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In local mode, sync metadata and summaries you review. In automatic mode, code is built on Bystep servers for previews and publishing. AI processing follows the connection you choose.`)
};

const id_mk_sec_sub = /** @type {(inputs: Mk_Sec_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pada mode lokal, sinkronkan metadata dan ringkasan yang kamu tinjau. Pada mode otomatis, kode dibangun di server Bystep untuk pratinjau dan penerbitan. Penggunaan layanan AI mengikuti koneksi yang dipilih.`)
};

/**
* | output |
* | --- |
* | "In local mode, sync metadata and summaries you review. In automatic mode, code is built on Bystep servers for previews and publishing. AI processing follows ..." |
*
* @param {Mk_Sec_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_sub = /** @type {((inputs?: Mk_Sec_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_sub(inputs)
	return en_mk_sec_sub(inputs)
});